import { IconProps, iconA11yProps } from '../types';

export const Play = ({ classNames, label }: IconProps) => (
    <svg className={classNames} id="icon-start" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 18" {...iconA11yProps(label)}>
        <path d="M0,17V1C0,.18,.93-.29,1.59,.2L12.42,8.2c.54,.4,.54,1.21,0,1.61L1.59,17.8c-.66,.49-1.59,.02-1.59-.8Z" />
    </svg>
);
